module.exports = __webpack_public_path__ + "static/media/Text-Yellow.39cdc04c.svg";